import React from 'react';
import { ReactComponent as CheckMarkIcon } from '../../assets/icons/svg/shared/ic-shared-success.svg';

export enum LiliCheckboxType {
  REGULAR,
  DISABLED,
  ERROR,
  ATTENTION,
}

export enum LiliCheckboxSize {
  SMALL,
  MEDIUM,
  LARGE,
}

export interface LiliCheckboxProps {
  id: string;
  containerClassName?: string;
  type?: LiliCheckboxType;
  size?: LiliCheckboxSize;
  checked: boolean;
  onCheckedChange: (isChecked: boolean) => void;
}

export const LiliCheckbox = ({
  id,
  containerClassName,
  type = LiliCheckboxType.REGULAR,
  size = LiliCheckboxSize.SMALL,
  checked = false,
  onCheckedChange,
}: LiliCheckboxProps) => {
  const handleCheckChange = (e: any) => {
    onCheckedChange(e.target.checked);
  };

  const getPredefinedIconSize = () => {
    switch (size) {
      case LiliCheckboxSize.SMALL:
        return 'min-h-[12px] min-w-[12px]';
      case LiliCheckboxSize.MEDIUM:
        return 'min-h-[20px] min-w-[20px]';
      case LiliCheckboxSize.LARGE:
        return 'min-h-[28px] min-w-[28px]';
      default:
        return '';
    }
  };

  const getPredefinedSizes = () => {
    switch (size) {
      case LiliCheckboxSize.SMALL:
        return 'min-h-[16px] min-w-[16px]';
      case LiliCheckboxSize.MEDIUM:
        return 'min-h-[24px] min-w-[24px]';
      case LiliCheckboxSize.LARGE:
        return 'min-h-[32px] min-w-[32px]';
      default:
        return '';
    }
  };

  const getClassNameByType = () => {
    const baseClasses = 'flex relative border rounded outline-none';
    let typeClasses: string;

    switch (type) {
      case LiliCheckboxType.REGULAR:
        typeClasses = 'bg-bw00 border-bw06 ';
        break;
      case LiliCheckboxType.DISABLED:
        typeClasses = 'bg-bw02 border-bw03 cursor-not-allowed';
        break;
      case LiliCheckboxType.ERROR:
        typeClasses = 'bg-red00 border-red02';
        break;
      case LiliCheckboxType.ATTENTION:
        typeClasses = 'bg-bw00 border-action05 shadow-allAround';
        break;
      default:
        typeClasses = 'border-gray-400';
    }

    if (checked) {
      typeClasses += ' border-bw07 bg-action00';
    }
    if (type !== LiliCheckboxType.DISABLED) {
      typeClasses += ' hover:border-bw07 hover:bg-action00';
    }

    return `${baseClasses} ${typeClasses} ${getPredefinedSizes()}`;
  };

  return (
    <div className={`${getClassNameByType()} items-center justify-center ${containerClassName}`}>
      {checked && <CheckMarkIcon className={`text-action03 absolute ${getPredefinedIconSize()}`} />}
      <input
        type='checkbox'
        id={id}
        onChange={handleCheckChange}
        checked={checked}
        className='appearance-none z-20 inset-0 absolute'
        disabled={type === LiliCheckboxType.DISABLED}
      />
    </div>
  );
};
